import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsRewind2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m3-12L8 6.4V4L3 8l5 4V9.6l3 2.4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsRewind2
